module.exports = __webpack_public_path__ + "static/media/verdeLips.645cd5ad.jpg";